import { Component, OnDestroy, OnInit } from '@angular/core';

import { UntypedFormGroup } from '@angular/forms';

import { Actions, ofActionSuccessful } from '@ngxs/store';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { delay, distinctUntilChanged } from 'rxjs/operators';

import { CoreFacade } from '@core/core.module';

import { LoadCourtsAction, SaveBlockedSlotSuccessAction } from '../../+store/blocked-slot-save.actions';
import { BlockedSlotSaveInputModel } from '../../models/blocked-slot-save-input.model';
import { BlockedSlotSaveFormService } from '../../services/blocked-slot-save-form.service';
import { BlockedSlotSaveFacade } from './../../+store/blocked-slot-save.facade';


@Component({
    selector: 'app-blocked-slot-save-modal',
    templateUrl: './blocked-slot-save-modal.component.html',
    styleUrls: ['./blocked-slot-save-modal.component.scss'],
    standalone: false
})
export class BlockedSlotSaveModalComponent implements OnInit, OnDestroy {
    form: UntypedFormGroup;

    saveSpinner$ = this.blockedSlotFacade.spinner$;
    isFormValid$ = this.blockedSlotFacade.isFormValid$;
    clubs$ = this.coreFacade.clubs$;
    clubCourts$ = this.blockedSlotFacade.clubCourts$;
    blockedSlotTypes$ = this.blockedSlotFacade.blockedSlotTypes$;
    isDateSelected$ = this.blockedSlotFacade.isDateSelected$;
    showSpinner$ = this.blockedSlotFacade.showSpinner$;

    public input: BlockedSlotSaveInputModel;

    private subscriptions: Subscription = new Subscription();
    private formLoaded: boolean = false;

    constructor(
        public bsModalRef: BsModalRef,
        private blockedSlotFacade: BlockedSlotSaveFacade,
        private formService: BlockedSlotSaveFormService,
        private coreFacade: CoreFacade,
        private actions$: Actions
    ) { }

    ngOnInit(): void {
        this.blockedSlotFacade.loadCourts(this.input.clubId, this.input.date);

        this.form = this.formService.initForm();

        this.subscriptions.add(
            this.actions$.pipe(ofActionSuccessful(LoadCourtsAction), delay(10)).subscribe(() => {
                if (!this.formLoaded) {
                    this.blockedSlotFacade.loadForm(this.input);
                    this.formLoaded = true;
                }
            })
        );

        this.subscriptions.add(
            this.actions$.pipe(ofActionSuccessful(SaveBlockedSlotSuccessAction)).subscribe(() => {
                this.bsModalRef.hide();
            })
        );

        this.subscriptions.add(
            this.form.controls.date.valueChanges
                .pipe(distinctUntilChanged((prev, curr) => (prev && curr && prev.value === curr.value) || (!prev && !curr)))
                .subscribe(value => {
                    if (this.formLoaded && value) {
                        this.blockedSlotFacade.loadCourts(null, value);
                    }
                })
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
        this.blockedSlotFacade.clearSaveForm();
    }

    onSave(): void {
        this.blockedSlotFacade.saveBlockedSlot();
    }

    onClubsChanged(value): void {
        this.blockedSlotFacade.loadCourts(value);
    }

    public get startDateSelected() {
        return this.form.controls.date.value !== null;
    }
}
